<template lang="pug">
  b-container(fluid="lg")
    .box.sombra(v-if="region")
      h3 {{region.name}}
      region-form.mt-5(v-if="region" :region="region" :editMode="true")
      list-shipping-services(style="margin-top:50px")
      list-communes(style="margin-top:50px")
</template>

<script>
import RegionForm from '../components/region/RegionForm'
import ListCommunes from '../components/region/commune/ListCommunes'
import ListShippingServices from '../components/shippingService/ListShippingServices.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    RegionForm,
    ListCommunes,
    ListShippingServices
  },
  methods: {
    ...mapActions(['getRegion'])
  },
  computed: {
    ...mapGetters(['region'])
  },
  async created () {
    this.getRegion({ regionId: this.$route.params.regionId })
  }
}
</script>
